// packages/ui/src/utils/use-mobile.ts
import * as React from "react";

function useMediaQuery(query: string) {
  const getSnapshot = () => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia(query).matches;
  };

  const subscribe = (callback: () => void) => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
    const mql = window.matchMedia(query);

    const handler = () => callback();

    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }

    mql.addListener?.(handler);
    return () => mql.removeListener?.(handler);
  };

  return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  return useMediaQuery(query);
}
